import { ServerResponseStatus } from "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { transactionMappingKeys } from "./mapper.js";
class TransactionDownloadServerStrategy {
  _mapper;
  _service;
  constructor(mapper, service) {
    this._mapper = mapper;
    this._service = service;
  }
  process(request) {
    const columns = request.keys?.map((k) => {
      const queryField = this._mapper.map(
        k,
        transactionMappingKeys.viewModelKeys,
        transactionMappingKeys.downloadFields
      );
      return {
        name: request.headers[k] ?? k,
        field: queryField
      };
    });
    return this._service.getDownloadLink({
      filter: request.filter,
      columns,
      report_name: request.filename
    }).pipe(
      map((response) => ({
        status: response?.status === ServerResponseStatus.Success ? "Success" : "Failed",
        link: response?.responsePayload,
        mode: "server"
      }))
    );
  }
}
export {
  TransactionDownloadServerStrategy
};
//# sourceMappingURL=downloadStrategy.js.map
